import { ServerError } from "@/pages/errorPages/serverError";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/serverError")({
  component: ServerError,
});
